// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vuetify from 'vuetify'
import VueResource from 'vue-resource'
import VueLodash from 'vue-lodash'
import lodash from 'lodash'
import i18n from './i18n'
import 'vuetify/dist/vuetify.min.css'

Vue.config.productionTip = false

/* eslint-disable no-new */
Vue.use(
  Vuetify, {
    theme: {
      primary: '#0072CE'
    }
  })
Vue.use(VueResource)
// const options = {}
// Vue.use(VueLodash, options)
Vue.use(VueLodash, { name: 'custom', lodash: lodash })

Vue.http.options.root = process.env.API_URL
Vue.http.options.crossOrigin = true
// Vue.http.headers.common['Access-Control-Allow-Origin'] = 'http://147.83.153.203:8080'

Vue.router = router

Vue.use(require('@websanova/vue-auth'), {
  auth: require('@websanova/vue-auth/drivers/auth/bearer.js'),
  http: require('@websanova/vue-auth/drivers/http/vue-resource.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  loginData: {url: process.env.API_URL + 'login', method: 'POST', redirect: '/home', fetchUser: true},
  refreshData: {enabled: false},
  rolesVar: 'role',
  parseUserData: function (data) {
    return data
  }
})

new Vue({
  el: '#app',
  router,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js